import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ControlValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { FormUtils } from '@app/utils/form-utils';
import { HypoControlsBaseComponent } from '@app/components/form-components/hypo-control-base/hypo-control-base.component';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatError, MatHint, MatInput, MatSuffix } from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { NgTemplateOutlet } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { TooltipComponent } from '@app/components/tooltip/tooltip.component';

@Component({
    selector: 'app-hypo-input',
    templateUrl: './hypo-input.component.html',
    styleUrls: ['./hypo-input.component.scss'],
    exportAs: 'hypoInput',
    imports: [
        MatFormField,
        ReactiveFormsModule,
        MatInput,
        MatAutocompleteTrigger,
        NgxMaskDirective,
        MatError,
        MatHint,
        MatSuffix,
        NgTemplateOutlet,
        MatButton,
        MatIcon,
        TooltipComponent,
    ],
})
export class HypoInputComponent extends HypoControlsBaseComponent implements ControlValueAccessor, OnInit, OnDestroy {
    @Input() label: string = '';
    @Input() maskSuffix: string = '';
    @Input() suffix: string = '';
    @Input() mask: string = '';
    @Input() inputmode: string = 'text';
    @Input() patternErrorMessage: string = '';
    @Input() dropSpecialCharacters: boolean = true;
    @Input() step: number | undefined;
    @Input() suffixTemplate: TemplateRef<any>;
    @Input() suffixFill: boolean = true;
    @Input() matAutocomplete: MatAutocomplete;
    @Input() readOnly: boolean = false;
    @Input() public highlight: boolean = false;
    @Input() public hint: string;

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    onBlur() {
        this.onTouched();
    }

    public plusValue() {
        this.markAsTouched();
        if (!this.input.disabled) {
            FormUtils.plusValue(this.input, this.step);
        }
    }

    public minusValue() {
        this.markAsTouched();
        if (!this.input.disabled) {
            FormUtils.minusValue(this.input, this.step);
        }
    }
}
